import React from 'react';
import { motion } from 'framer-motion';
import { storiesData } from '../../data/stories';
export function StoriesTimeline() {
  return <div className="min-h-screen pt-24 pb-32 px-6 md:px-12 max-w-3xl mx-auto overflow-y-auto hide-scrollbar" data-id="element-87">
      <div className="mb-12 text-center" data-id="element-88">
        <h2 className="text-4xl font-serif text-warm-text mb-4" data-id="element-89">
          Family Stories
        </h2>
        <p className="text-warm-muted text-lg" data-id="element-90">
          Memories passed down through generations.
        </p>
      </div>

      <div className="relative" data-id="element-91">
        {/* Vertical Line */}
        <div className="absolute left-8 md:left-24 top-4 bottom-0 w-px border-l-2 border-dashed border-warm-border" data-id="element-92" />

        <div className="space-y-12" data-id="element-93">
          {storiesData.map((story, index) => <motion.div key={story.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.15,
          duration: 0.6,
          ease: 'easeOut'
        }} className="relative flex flex-col md:flex-row gap-6 md:gap-12" data-id="element-94">
              {/* Year Marker */}
              <div className="flex items-center gap-4 md:w-32 shrink-0 md:justify-end z-10" data-id="element-95">
                <span className="font-serif text-2xl text-warm-cyan bg-warm-bg py-1 px-2" data-id="element-96">
                  {story.year}
                </span>
                <div className="w-4 h-4 rounded-full bg-warm-cyan border-4 border-warm-bg shrink-0 hidden md:block" data-id="element-97" />
              </div>

              {/* Mobile Node */}
              <div className="absolute left-8 top-10 w-4 h-4 -ml-2 rounded-full bg-warm-cyan border-4 border-warm-bg md:hidden z-10" data-id="element-98" />

              {/* Content Card */}
              <div className="flex-1 bg-warm-surface border border-warm-border rounded-3xl p-6 ml-12 md:ml-0 shadow-warm hover:border-warm-muted transition-colors" data-id="element-99">
                <h3 className="text-2xl font-serif text-warm-text mb-3" data-id="element-100">
                  {story.title}
                </h3>
                <p className="text-warm-muted leading-relaxed mb-6 text-lg" data-id="element-101">
                  {story.snippet}
                </p>

                {story.photo && <div className="mb-6 rounded-2xl overflow-hidden border border-warm-border" data-id="element-102">
                    <img src={story.photo} alt={story.title} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-700" data-id="element-103" />
                  </div>}

                <div className="flex items-center gap-3" data-id="element-104">
                  <img src={story.author.avatar} alt={story.author.name} className="w-8 h-8 rounded-full object-cover border border-warm-border" data-id="element-105" />
                  <span className="text-sm font-medium text-warm-muted" data-id="element-106">
                    Shared by {story.author.name}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}